export default {
  // 页面标题
  title: 'Viral ideas',
  
  // 设置弹窗
  setup: {
    title: 'Brands to generate viral ideas',
    placeholder: 'Please enter the website address',
    addButton: 'add',
    errorMessage: 'Please enter the correct website address'
  },
  
  // 标签相关
  tags: {
    remove: 'Remove',
    add: 'Add'
  },
  
  // 内容相关
  content: {
    views: 'views',
    platform: 'Platform',
    user: 'User'
  },
  
  // 加载状态
  loading: {
    title: 'Loading...',
    description: 'Please wait while we fetch viral ideas'
  },
  
  // 错误状态
  error: {
    title: 'Error occurred',
    description: 'Failed to load viral ideas'
  },
  
  // 空状态
  empty: {
    title: 'No viral ideas found',
    description: 'Try adding some brands to generate viral ideas'
  },
  
  // 侧边栏
  sidebar: {
    startCampaign: 'Start a campaign',
    startTask: 'Start a task',
    viralIdeas: 'Viral ideas',
    headsDna: 'AhaCreator\'s DNA'
  }
};
